import React from 'react';
import ModalConfirm from '../modal_confirm';

const MessageConfirmButton = ({
  event,
  eventsFollowUserMemberId,
  isExistingMessageGroup,
}) => {
  const newMessageRef = React.useRef(null);

  const createMessageRoom = React.useCallback(
    () => {
      const url = `/message/create_direct_message/${eventsFollowUserMemberId}/${
        event.circle_id
      }`;
      window.location.href = url;
    },
    [eventsFollowUserMemberId, event]
  );

  return (
    <React.Fragment>
      <div className="dropdown dropleft">
        <div
          data-toggle="dropdown"
          data-display="static" // Android端末で一番下の要素までスクロールできない問題が発生したため、原因となっているPopper.jsを無効化
          style={{ padding: '20px' }}
        >
          <img
            style={{ padding: '0 2px 0 12px' }}
            id="dropdownMenu"
            src="/assets2019/img/icon_reader.svg"
            alt=""
          />
        </div>

        <div className="dropdown-menu" aria-labelledby="dropdownMenu">
          {isExistingMessageGroup ? (
            <a
              href={`/message/create_direct_message/${eventsFollowUserMemberId}/${
                event.circle_id
              }`}
              className="btn btn-light dropdown-item"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>
              メッセージ
            </a>
          ) : (
            <button
              onClick={() => newMessageRef.current.openModal()}
              className="dropdown-item btn btn-light"
              type="button"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>
              メッセージ
            </button>
          )}
        </div>

				<ModalConfirm
					ref={newMessageRef}
					approveFunc={createMessageRoom}
					title={'メッセージ'}
					content={'メッセージを開通しますか？'}
					/>
			</div>
    </React.Fragment>
  );
};

export default MessageConfirmButton;
